import { formatDecimal, getTextColor } from "../../utils/helpers"
export const allowedCompaniesPickUpName = new Set([10, 161, 641, 4185, 5415, 6007, 5986, 5362, 6692, 1390, 2661, 2719, 3800, 2259, 441, 6495, 1380]);
export const allowdConductorNo = new Set([1, 6007, 10, 6692])
export const allowdDriverNo = new Set([1, 6007, 10, 6692, 4574])
export const tripColumnDef = [
    { headerName: 'Time', field: 'TripTime', headerSx: { textAlign: 'left', width: '80px' }, isSorted: true, },
    { headerName: 'Operator Name', field: 'B2CName', headerSx: { textAlign: 'left', width: '140px' }, isSorted: true, },
    { headerName: 'Service Name', field: 'ChartServiceName', headerSx: { textAlign: 'left', width: '180px' }, isSorted: true, },
    { headerName: 'Service Type', field: 'seatType', headerSx: { textAlign: 'left', width: '100px' }, isSorted: true, },
    { headerName: 'Class Type', field: 'BusType', headerSx: { textAlign: 'left', width: '90px' }, isSorted: true, },
    { headerName: 'Price', field: 'tripFare', headerSx: { textAlign: 'left', width: '90px' }, isSorted: false, },
    { headerName: 'Avl', field: 'Availability', headerSx: { textAlign: 'right', width: '25px' }, isSorted: false, },
    { headerName: 'Dis', field: 'HasDiscountPolicy', headerSx: { textAlign: 'right', width: '25px' }, isSorted: false, },

]


export const fareUpdateLimitObj = {
    seaterHigh: 'SeaterHigh',
    seaterLow: 'SeaterLow',
    sleeperHigh: 'SleeperHigh',
    sleeperLow: 'SleeperLow',
    slumberHigh: 'SlumberHigh',
    slumberLow: 'SlumberLow'
}

export const bkgTypeOptList = [
    { id: "AC", label: "Confirm", field: 'AllowConfirmBooking' },
    { id: "AP", label: "Phone", field: 'AllowPhoneBooking' },
]
export const genderOptList = [
    { label: 'Male', id: 'M' },
    { label: 'Female', id: 'F' },
]
export const paymentOptList = [
    { label: 'Cash', key: 'Cash', id: 1 },
    { label: 'QR Code', key: 'QRCode', id: 2 },
]
export const bkgDetailsObj = {
    tripDetails: {},
    cancelPolicyData: [],
    roleRight: {},
    bkgDeatails: [],
    pickUp: [],
    dropOff: [],
    autoCancelMins: 0,
    phoneNumber: '',
    email: '',

    seaterHigh: 0,
    seaterLow: 0,
    sleeperHigh: 0,
    sleeperLow: 0,
    slumberHigh: 0,
    slumberLow: 0,
    servicecharge: 0,
    serviceTaxPct: 0,
    hasSTax: 0,
    hasDiscountPolicy: false,
    discountAmt: 0,
    discountPer: 0,
    paymentMode: [],
    remarks: '',
    gstNo: '',
    verfiyGst: false,
    CommissionAmt: 0,
    CommissionPer: 10,
    CommseatAmt: 0,
    CommslprAmt: 0,
    tripCompanyID: 0,
    agentBalance: 0,

    isDisableRemarks: false,

    routeCity: [],


    manualTicketNo: '',
    limitOnFareChange: 0,
    limitOnFareChangePer: 0,
    gstData: {},
    seatFareIsDiscount: false,
}

export const filterOptObj = {
    chartData: [],
    pickUp: [],
    dropOff: [],
    paymentMode: [],
    allPaymentMode: [],
}

export const chartDataObj = {
    lableList: [],
    seatRowData: {},
    bookSeat: 0,
    available: 0,
    bookSeatPhone: 0,
}

export const emptySeatObj = {
    SeatLabel: '',
    baseFare: 0,
}

export const seatDefaultObj = {
    SeatLabel: '',
    gender: [genderOptList[0]],
    name: '',
    age: '',
}

export const generateBkgSeatNewStyle = (ell, isAlreadySeat = false, userDetails = {}, chartScale = 1) => {
    if (ell.AmenityBgColor) {
        return {
            minWidth: `${(ell.Width === 2 ? 80 : 40) * chartScale}px`,
            height: `${(ell.Height === 2 ? 80 : 40) * chartScale}px`,
            fontSize: `${10 * chartScale}px`,
            borderWidth: `${1 * chartScale}px`,
            borderStyle: 'solid',
            borderColor: '#A9A9A9',
            backgroundColor: ell.AmenityBgColor,
            color: '#202020',
            textAlign: 'center',
            cursor: 'default',
            position: 'relative',
        }
    }

    return {
        minWidth: `${(ell.Width === 2 ? 80 : 40) * chartScale}px`,
        height: `${(ell.Height === 2 ? 80 : 40) * chartScale}px`,
        fontSize: `${12 * chartScale}px`,
        borderWidth: ell.IsAisle ? 0 : `${1.5 * chartScale}px`,
        borderStyle: 'solid',
        borderColor: ell.IsBkgAvailable === 0 ? ell.BookingType === 'AP' ? '#FFFF00' : ell.ForAgentID === userDetails?.AgentID ? `rgb(${userDetails?.ColorCode})` : '#FF0000' : ell.IsAisle ? 'transparent' : ell.IsAC === 1 ? 'red' : '#A9A9A9',
        backgroundColor: ell.IsBkgAvailable === 0 ? ell.BookingType === 'AP' ? '#FFFF00' : ell.ForAgentID === userDetails?.AgentID ? `rgb(${userDetails?.ColorCode})` : '#FF0000' : ell.IsAisle ? 'transparent' : isAlreadySeat ? '#FFA500' : ell.SeatTypeID === 3 ? 'rgb(255, 255, 224)' : (ell.IsAvailable === 0 && ell.IsAisle !== 1) ? '#FF0000' : 'LightGreen',
        color: (isAlreadySeat || ell.IsBkgAvailable === 0) || (ell.IsAvailable === 0 && ell.IsAisle !== 1) ? getTextColor(ell.BookingType === 'AP' ? '255,255,0' : ell.ForAgentID === userDetails?.AgentID ? userDetails?.ColorCode : '255,0,0') || '#fff' : '#202020',
        textAlign: 'center',
        cursor: "pointer",
        position: 'relative'

    }
}


export const tripDetailsFormat = (tripArr) => {
    return tripArr.map((trip) => {
        let tripFare = []
        let seatType = [trip.ACNAC]
        if (Number(trip.SeaterLow) > 0 || Number(trip.SeaterHigh) > 0) {
            seatType.push('sit')
            if (Number(trip.SeaterLow) > 0) {
                tripFare.push(Number(trip.SeaterLow))
            }
            if (Number(trip.SeaterHigh) > 0) {
                tripFare.push(Number(trip.SeaterHigh))
            }
        }
        if (Number(trip.SleeperLow) > 0 || Number(trip.SleeperHigh) > 0) {
            seatType.push('slp')
            if (Number(trip.SleeperLow) > 0) {
                tripFare.push(Number(trip.SleeperLow))
            }
            if (Number(trip.SleeperHigh) > 0) {
                tripFare.push(Number(trip.SleeperHigh))
            }
        }
        if (Number(trip.SlumberLow) > 0 || Number(trip.SlumberHigh) > 0) {
            seatType.push('slm')
            if (Number(trip.SlumberLow) > 0) {
                tripFare.push(Number(trip.SlumberLow))
            }
            if (Number(trip.SlumberHigh) > 0) {
                tripFare.push(Number(trip.SlumberHigh))
            }
        }
        return {
            ...trip,
            ChartServiceName: trip?.ChartName?.split('..-')[1] || '',
            seatType: seatType.join(','),
            tripFare: tripFare.join(','),
        }
    })
}


const SEAT_AMENITY_MAP = {
    1: { SeatLabel: 'Toilet', AmenityBgColor: 'rgb(155, 242, 254)' },
    2: { SeatLabel: 'E Ex', AmenityBgColor: 'rgb(218, 180, 131)' },
    3: { SeatLabel: 'R Ex', AmenityBgColor: 'rgb(255, 147, 187)' },
}

const applySeatAmenity = (seat = {}) => {
    const amenityId = Number(seat?.SeatAmenityID)
    if (!amenityId || !SEAT_AMENITY_MAP[amenityId]) {
        return seat
    }
    const amenity = SEAT_AMENITY_MAP[amenityId]
    return {
        ...seat,
        IsAisle: 0,
        IsAvailable: 0,
        IsBkgAvailable: 0,
        SeatLabel: amenity.SeatLabel,
        AmenityBgColor: amenity.AmenityBgColor,
    }
}

export const chartFormatData = (arr, bkgData = [], userDetails = {}, roleRight = {}) => {
    return arr.map((obj) => {
        let baseFare = Number(obj.Fare)
        if (obj.HasSTax === 1) {
            baseFare -= Number(obj.ServiceTax)
        }
        let disBaseFare = 0
        let match = bkgData.filter(item2 => item2.SeatNo === obj.SeatLabel && item2.ForAgentID === userDetails?.AgentID).sort((a, b) => a.FromPos - b.FromPos);
        let agentmatch = bkgData.filter(item2 => item2.SeatNo === obj.SeatLabel && item2.ForAgentID === userDetails?.AgentID).sort((a, b) => a.FromPos - b.FromPos);
        let bookingTypeArr = agentmatch.map((item) => item.BookingType)
        if (roleRight?.AllowFareChange2 === 1) {
            let limitOnFareChange = Number(roleRight?.LimitOnFareChange) || 0
            let limitOnFareChangePer = Number(roleRight?.LimitOnFareChangePer) || 0
            if (limitOnFareChangePer > 0) {
                disBaseFare = Math.round((baseFare * (100 - limitOnFareChangePer)) / 100)
            } else {
                disBaseFare = baseFare - limitOnFareChange
            }
        } else {
            disBaseFare = baseFare
        }
        return applySeatAmenity({
            ...obj,
            ...match?.[0],
            IsBkgAvailable: obj.IsAvailable,
            bookingTypeArr: bookingTypeArr,
            seatInfo: agentmatch,
            baseFare,
            disBaseFare,
            orgBaseFare: baseFare,
            SeatAmenityID: obj.SeatAmenityID,
        })
    })
}



export const calcSeatFare = (selectedSeat = [], bkgDeatails) => {
    let tripDetails = bkgDeatails?.tripDetails || {}
    let totalAmt = {
        discount: 0,
        tax: 0,
        grandAmt: 0,
        baseFare: 0,
        seaterCount: 0,
        sleeperCount: 0,
        slumperCount: 0,
        seaterAmt: 0,
        sleeperAmt: 0,
        slumperAmt: 0,
        pickUpChrg: 0,
        dropOffChrg: 0,
        serviceChrg: 0,
        pickUpAndDropOffChrg: 0,
    }

    if (Object.keys(tripDetails).length !== 0) {

        selectedSeat.forEach((obj) => {
            let seaterCount = 0
            let sleeperCount = 0
            let slumperCount = 0
            let seaterAmt = 0
            let sleeperAmt = 0
            let slumperAmt = 0
            let tax = 0
            let discount = 0
            let pickUpChrg = 0
            let dropOffChrg = 0

            if (obj.SeatTypeID === 1) {
                seaterCount += 1
                seaterAmt += Number(obj.baseFare)
            } else if (obj.SeatTypeID === 2) {
                sleeperCount += 1
                sleeperAmt += Number(obj.baseFare)
            } else if (obj.SeatTypeID === 3) {
                slumperCount += 1
                slumperAmt += Number(obj.baseFare)
            }
            if (bkgDeatails?.hasSTax) {
                tax = formatDecimal((Number(obj.baseFare) * Number(bkgDeatails?.serviceTaxPct)) / 100)
            }

            if (bkgDeatails?.hasDiscountPolicy) {
                if (bkgDeatails.discountPer > 0) {
                    discount = formatDecimal((Number(obj.baseFare) * Number(bkgDeatails?.discountPer)) / 100)
                } else {
                    discount = Number(bkgDeatails?.discountAmt)
                }
            }
            if (bkgDeatails.pickUp.length > 0) {
                let pickUp = { ...bkgDeatails.pickUp?.[0] }
                if (Number(pickUp.pickupCharge_per) > 0) {
                    pickUpChrg = formatDecimal((Number(obj.baseFare) * Number(pickUp?.pickupCharge_per)) / 100)
                } else {
                    pickUpChrg = Number(pickUp?.pickupCharge_rs)
                }

            }

            if (bkgDeatails.dropOff.length > 0) {
                let dropOff = { ...bkgDeatails.dropOff?.[0] }
                if (Number(dropOff.DropoffChargePer) > 0) {
                    dropOffChrg = formatDecimal((Number(obj.baseFare) * Number(dropOff?.DropoffChargePer)) / 100)
                } else {
                    dropOffChrg = Number(dropOff?.DropoffChargeRs)
                }

            }
            let pickUpAndDropOffChrg = Number(pickUpChrg) + Number(dropOffChrg)
            let grandAmt = Number(obj.baseFare) + Number(tax) + Number(bkgDeatails.servicecharge) + Number(pickUpAndDropOffChrg) - Number(discount)
            totalAmt = {
                ...totalAmt,
                baseFare: formatDecimal(Number(totalAmt.baseFare) + Number(obj.baseFare)),
                tax: formatDecimal(Number(totalAmt.tax) + Number(tax)),
                discount: formatDecimal(Number(totalAmt.discount) + Number(discount)),
                pickUpChrg: formatDecimal(Number(totalAmt.pickUpChrg) + Number(pickUpChrg)),
                dropOffChrg: formatDecimal(Number(totalAmt.dropOffChrg) + Number(dropOffChrg)),
                pickUpAndDropOffChrg: formatDecimal(Number(totalAmt.pickUpAndDropOffChrg) + Number(pickUpAndDropOffChrg)),
                grandAmt: formatDecimal(Number(totalAmt.grandAmt) + grandAmt),
                seaterCount: formatDecimal(Number(totalAmt.seaterCount) + Number(seaterCount)),
                sleeperCount: formatDecimal(Number(totalAmt.sleeperCount) + Number(sleeperCount)),
                slumperCount: formatDecimal(Number(totalAmt.slumperCount) + Number(slumperCount)),
                seaterAmt: formatDecimal(Number(totalAmt.seaterAmt) + Number(seaterAmt)),
                sleeperAmt: formatDecimal(Number(totalAmt.sleeperAmt) + Number(sleeperAmt)),
                slumperAmt: formatDecimal(Number(totalAmt.slumperAmt) + Number(slumperAmt)),
            }
        })
    }
    return { ...totalAmt, grandAmt: Math.round(totalAmt.grandAmt) }
}


export const updateSelectedSeat = (fieldName, value, seatArr = []) => {
    let newData = seatArr?.map((obj) => {
        if (fieldName === 'seaterLow' && (obj?.SeatTypeID === 1 && obj?.IsAC === 0)) {
            return { ...obj, baseFare: Number(value) }
        } else if (fieldName === 'seaterHigh' && (obj?.SeatTypeID === 1 && obj?.IsAC === 1)) {
            return { ...obj, baseFare: Number(value) }
        } else if (fieldName === 'sleeperLow' && (obj?.SeatTypeID === 2 && obj?.IsAC === 0)) {
            return { ...obj, baseFare: Number(value) }
        } else if (fieldName === 'sleeperHigh' && (obj?.SeatTypeID === 2 && obj?.IsAC === 1)) {
            return { ...obj, baseFare: Number(value) }
        } else if (fieldName === 'slumberLow' && (obj?.SeatTypeID === 3 && obj?.IsAC === 0)) {
            return { ...obj, baseFare: Number(value) }
        } else if (fieldName === 'slumberHigh' && (obj?.SeatTypeID === 3 && obj?.IsAC === 1)) {
            return { ...obj, baseFare: Number(value) }
        }
        return obj
    })
    return newData
}


export const formatCancelPolicy = (arr = []) => {
    let newData = []
    arr.forEach((obj, index) => {
        let totalMinutes = obj.MinsBefore;

        const days = Math.floor(totalMinutes / 1440); // 1 day = 1440 mins
        totalMinutes = totalMinutes % 1440;

        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        let formatTime = "";
        if (days > 0) formatTime += `${days} Day${days > 1 ? "s" : ""} `;
        if (hours > 0) formatTime += `${hours} Hour${hours > 1 ? "s" : ""} `;
        if (minutes > 0) formatTime += `${minutes} Minute${minutes > 1 ? "s" : ""}`;
        formatTime = formatTime.trim();

        const prevTime = index > 0 ? newData[index - 1].lastTime : "0 Hours";

        newData.push({
            name:
                index === arr.length - 1
                    ? `Before ${formatTime} Within Journey Time`
                    : `Between ${prevTime} and ${formatTime} Within Journey Time`,
            value: obj.DeductPer > 0 ? `${obj.DeductPer}%` : `Rs.${obj.DeductAmt}`,
            lastTime: formatTime
        })
    })
    return newData
}

export const handleConfirmFare = (arr = []) => {
    let totalAmt = {
        baseFare: 0,
        seaterCount: 0,
        sleeperCount: 0,
        slumperCount: 0,
        seaterAmt: 0,
        sleeperAmt: 0,
        slumperAmt: 0,

    }
    arr.forEach((obj) => {
        if (obj.SeatTypeID === 1) {
            totalAmt.seaterCount += 1
            totalAmt.seaterAmt += Number(obj.Fare)
        } else if (obj.SeatTypeID === 2) {
            totalAmt.sleeperCount += 1
            totalAmt.sleeperAmt += Number(obj.Fare)
        } else if (obj.SeatTypeID === 3) {
            totalAmt.slumperCount += 1
            totalAmt.slumperAmt += Number(obj.Fare)
        }
        totalAmt.baseFare += Number(obj.Fare)
    })
    return { ...totalAmt }
}